import Component from "./GenericGameCard";
export default Component;
